module.exports = __webpack_public_path__ + "img/zenodo.a9594e0c.png";